'use client';
import { useEffect, useRef } from 'react';

const VehicleDealerImagePro = ({ vin, dealerImageProSellerId }) => {
  const extView = useRef(null);

  useEffect(() => {
    if (!extView.current) return;

    const existingScript = document.getElementById('dipPhoton360Script');
    if (existingScript) existingScript.remove();

    const script = document.createElement('script');
    script.id = 'dipPhoton360Script';
    script.type = 'text/javascript';
    script.src = 'https://assets.dealerimagepro.com/v3/intelimotor.js';
    script.setAttribute('data-dealer', dealerImageProSellerId);
    script.setAttribute('data-type', 'gallery');
    script.setAttribute('data-vin', vin);

    script.onload = () => {
      if (typeof globalThis?.window?.initViewer === 'function') {
        globalThis.window.initViewer();
      }
    };

    extView.current.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById('dipPhoton360Script');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [vin, dealerImageProSellerId]);

  return (
    <div id="ext-view" ref={extView} className="w-full min-h-0">
      <div id="gallery" />
    </div>
  );
};

export default VehicleDealerImagePro;
